import { ContractStatus } from '../../mdqx-graphql-types';

export class ContractStatusEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(contractStatusType: ContractStatus | null) {
        if (
            contractStatusType &&
            contractStatusType.id != null &&
            contractStatusType.name != null
        ) {
            this.Id = contractStatusType.id;
            this.Name = contractStatusType.name;
        } else {
            console.error('received broken ContractStatusType', contractStatusType);
            throw Error();
        }
    }
}
